export let classNameObj = { classBlocksData: [["class_name", "class_name"]] };
export let functionNameObj = { functionBlocksData: [] };
